import request from '@/utils/request'
import axios from 'axios'

export function getTeamMaterials(teamId, parentId) {
  return request({
    url: 'vteammaterials',
    method: 'get',
    params: {
      teamId: teamId || 0,
      parentId: parentId || 0
    }
  })
}

export function createTeamMaterialFolder(teamId, parentId, name) {
  return request({
    url: 'vteammaterialfolder',
    method: 'post',
    data: { teamId, parentId: parentId || 0, name }
  })
}

export function addTeamMaterialLink(teamId, parentId, name, url) {
  return request({
    url: 'vteammateriallink',
    method: 'post',
    data: { teamId, parentId: parentId || 0, name, url }
  })
}

export function renameTeamMaterial(id, name) {
  return request({
    url: 'vteammaterial',
    method: 'put',
    data: { id, name }
  })
}

export function deleteTeamMaterial(id) {
  return request({
    url: 'vteammaterial',
    method: 'delete',
    params: { id }
  })
}

export function uploadTeamMaterial(teamId, parentId, file, name) {
  const formData = new FormData()
  formData.append('file', file)
  if (name) {
    formData.append('name', name)
  }
  return axios.post(
    process.env.VUE_APP_BASE_API + 'uploadteammaterial?teamId=' + encodeURIComponent(teamId) +
      '&parentId=' + encodeURIComponent(parentId || 0),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'ECAPP-TWXHEADER': localStorage.getItem('ecmtctoken')
      }
    }
  )
}

export const TEAM_MATERIAL_ACCEPT =
  '.png,.jpg,.jpeg,.gif,.webp,.mp4,.webm,.mov,.pdf,.xls,.xlsx,.doc,.docx,.txt,.csv'

export function formatStorageBytes(bytes) {
  if (!bytes || bytes <= 0) return '0 B'
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
  return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB'
}

export function fileIconType(item) {
  if (!item) return 'folder-document'
  if (item.itemType === 'folder') return 'folder-document'
  if (item.itemType === 'link') return 'doc'
  const category = item.fileCategory || 'doc'
  const map = {
    image: 'tif',
    video: 'xml',
    pdf: 'pdf',
    excel: 'csv',
    word: 'doc',
    text: 'txt'
  }
  return map[category] || 'doc'
}
